import { Box, Button, Card, Collapse, Stack, Typography } from '@mui/material';
import {
    LoadingIndicator,
    useNotify,
    useTranslate,
    useUpdate,
} from 'react-admin';
import { useIdentityContext } from '../../components/identity';
import { useGetList } from 'ra-core';
import QuickbooksLogo from '../../assets/quickbooks_icon.jpeg';
import JobImportConfiguration from '../../connectors/JobImportConfiguration';
import moment from 'moment';

const RESOURCE = 'quickbooksConnectors';
const CONNECTOR_STATUS = {
    PENDING: 'pending',
    CONNECTED: 'connected',
};

const ConnectButton = () => {
    const translate = useTranslate();
    const connectQuickbooks = () => {
        origin = window.location.origin;
        const newWindow = window.open(
            origin + '/integrations/quickbooks',
            '_blank',
            'popup,resizable=1,width=1000,height=1000'
        );
        if (newWindow) newWindow.opener = null;
    };
    return (
        <Button
            variant="contained"
            className='integration-connect integration-button'
            sx={{
                width: '100%',
            }}
            onClick={connectQuickbooks}
        >
            {translate('resources.integrations.quickbooks.connect')}
        </Button>
    );
};

const DisConnectButton = ({ record }: any) => {
    const notify = useNotify();
    const translate = useTranslate();
    const [update, { isLoading }] = useUpdate();

    const disconnectQuickbooks = () => {
        update(
            RESOURCE,
            {
                id: record.id,
                data: { ...record, ...{ status: CONNECTOR_STATUS.PENDING } },
                previousData: record,
            },
            {
                mutationMode: 'pessimistic',
                onSuccess: (data: any) => {
                    notify(
                        'resources.integrations.quickbooks.disconnect_message'
                    );
                },
                onError: (error: any) => {
                    notify(`Element Failed Updated ${error.message}`);
                },
            }
        );
    };
    return (
        <Button
            variant="contained"
            size="large"
            sx={{
                width: '100%',
            }}
            disabled={isLoading}
            onClick={disconnectQuickbooks}
            className='integration-connect integration-button'
        >
            {translate('resources.integrations.quickbooks.disconnect')}
        </Button>
    );
};

const getLocalDate = value => {
    return moment.utc(value).local();
};

const ShowStatusTime = ({ record }) => {
    const fullFormat = 'MMM DD, YYYY  h:mm A';
    const isConnected = record.status == CONNECTOR_STATUS.CONNECTED;
    return (
        <>
            {isConnected ? (
                <Typography variant="caption">
                    Connected on{' '}
                    {getLocalDate(record.connected_time).format(fullFormat)}
                </Typography>
            ) : (
                <Typography variant="caption">
                    Disconnected on{' '}
                    {getLocalDate(record.disconnected_time).format(fullFormat)}
                </Typography>
            )}
        </>
    );
};
export const QuickbooksCard = (props: any) => {
    const translate = useTranslate();
    const identity = useIdentityContext();
    const { data, total } = useGetList(RESOURCE, {
        pagination: { page: 1, perPage: 1 },
        filter: { id: { _eq: identity?.company.quickbooks_connector_id||0 } },
    });

    if (!identity?.company) {
        return <LoadingIndicator />;
    }

    const isConnected = total > 0 && data[0].status == CONNECTOR_STATUS.CONNECTED;
    return (
        <Card
            sx={{
                p: 2,
            }}
            className='quick-book-setting-card'
        >
            <Stack
                direction={'row'}
                sx={{
                    alignItems: 'center',
                }}
                className='integration-setting-stack'
            >
                <Stack
                    sx={{
                        flex: 1,
                        flexDirection: 'row',
                        alignItems: 'center',
                    }}
                    className='integration-stack-body'
                >
                    <img
                        src={QuickbooksLogo}
                        alt={'Quickbooks Online'}
                        loading="lazy"
                        width={100}
                        height={100}
                        className='quickbook-setting-img'
                    />
                    <Stack
                        direction="column"
                        justifyContent="flex-start"
                        sx={{ marginLeft: 2 }}
                    >
                        <Typography variant="h5">
                            {translate(
                                'resources.integrations.quickbooks.title'
                            )}
                        </Typography>
                        {total > 0 && data && <ShowStatusTime record={data[0]} />}
                    </Stack>
                </Stack>
                <div className='integration-card-right'>
                    {isConnected ? (
                        <DisConnectButton record={data[0]} />
                    ) : (
                        <ConnectButton />
                    )}
                </div>
            </Stack>
            {data && <Collapse in={isConnected} timeout="auto" unmountOnExit>
                <JobImportConfiguration />
            </Collapse>}
        </Card>
    );
};
